// src/components/OfflineBanner.jsx
import { useState, useEffect } from 'react';

export default function OfflineBanner() {
  const [status, setStatus] = useState('online'); // online | offline | back-online

  useEffect(() => {
    const goOffline = () => {
      setStatus('offline');
    };

    const goOnline = () => {
      setStatus('back-online');
      setTimeout(() => setStatus('online'), 3000);
    };

    window.addEventListener('offline', goOffline);
    window.addEventListener('online',  goOnline);

    // Check initial state
    if (!navigator.onLine) setStatus('offline');

    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online',  goOnline);
    };
  }, []);

  if (status === 'online') return null;

  return (
    <div className={`offline-banner ${status === 'back-online' ? 'back-online' : ''}`}>
      {status === 'offline' ? (
        <>
          <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
            <line x1="1" y1="1" x2="23" y2="23"/>
            <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55M5 12.55a10.94 10.94 0 0 1 5.17-2.39M10.71 5.05A16 16 0 0 1 22.56 9M1.42 9a15.91 15.91 0 0 1 4.7-2.88M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01"/>
          </svg>
          No internet connection — some features may not work
        </>
      ) : (
        <>
          <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
          Back online
        </>
      )}
    </div>
  );
}
